export default { sha: '52be8cd3a54a626c086bbbe2dd6690e14038fd6c', buildNumber: 'undefined' }
